<template>
    <div>
        <div v-if="loading">
            <div>
                <div class="pull-left" style="margin-right: 15px;">
                    <div class="border-img" style="width: 80px">
                        <div class="loading-placeholder" style="width: 100%; height: 74px"></div>
                    </div>
                </div>
                <div class="pull-left">
                    <div>
                        <div class="loading-placeholder" style="width: 100px; height: 18px; margin-bottom: 4px"></div>
                        <div class="loading-placeholder" style="width: 120px; height: 18px; margin-bottom: 4px"></div>
                        <div class="loading-placeholder" style="width: 150px; height: 18px; margin-bottom: 4px"></div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div v-if="!loading && !property">
            O imóvel não pode ser carregado ou você não tem permissão para visualiza-lo(Referencia interna: {{ id }})...
        </div>
        <div v-if="!loading && property">
            <div>
                <construction-modal-link :id="property.id" :circling="circling">
                    <div class="pull-left" style="cursor: pointer">
                        <img v-if="property.highlight" class="border-img" v-bind:src="property.highlight" style="max-width: 80px; margin-right: 15px;">
                        <div v-if="!property.highlight" class="border-img" style="position: relative; width: 80px; height: 80px; margin-right: 15px;">
                            <div class="anchor-parent background-cover"
                                 style="margin: 3px; background-image: url(/assets/images/imagem-nao-disponivel-media.png);"></div>
                        </div>
                    </div>
                </construction-modal-link>
                <div class="pull-left">
                    <div>
                        <construction-modal-link :id="property.id" :circling="circling">
                            <a>Cod. <b>{{ property.user_code }}</b></a>
                        </construction-modal-link>

                        <br>
                        <construction-line :construction="property" name="simple-description"></construction-line>
                        <br>
                        <property-line :property="property" name="address"></property-line>
                    </div>
                    <div style="margin-top: 5px;">
                        <span class="timeline-link" v-if="property.latidude && property.longitude">
                            <a href="javascript:;" v-map-shadow :data="property">VER MAPA</a>
                            <span style="width: 10px; display: inline-block;"></span>
                        </span>
                    </div>
                    <div>
                        <slot name="extra"></slot>
                        <slot name="controls"></slot>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>
<script>
import ConstructionLine from "../construction/Line.vue";
import ConstructionModalLink from "../construction/ConstructionModalLink.vue";

const { client } = require('../../sci/helpers')

export default {
    components: {
        ConstructionModalLink,
        ConstructionLine,
        PropertyLine: require('../property/Line.vue')
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        circling: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    data () {
        return {
            loading: true,
            property: null
        }
    },
    ready () {
        client.silent().get(null, `/constructions/${this.id}`).then((r) => {
            this.loading = false
            this.property = r.data
        }).catch(() => {
            this.loading = false
        })
    }
}
</script>


// WEBPACK FOOTER //
// DelayedConstruction.vue?09f3829c